import { createContext, Dispatch, SetStateAction } from 'react'

import { MessageCenterChat, MessageCenterMessage, MessageCenterRoutes } from '../../types'

type MessageCenterChatManagerContext = {
  messages: MessageCenterMessage[]
  setMessages: Dispatch<SetStateAction<MessageCenterMessage[]>>
  chat: MessageCenterChat
  setChat: Dispatch<SetStateAction<MessageCenterChat>>
  routes: MessageCenterRoutes
}

const defaultMessageReturn = {
  header: {
    success: false,
  },
  body: {
    case_chat_message: {},
  },
}

const defaultChatReturn = {
  header: {
    success: false,
  },
  body: {
    case_chat: {},
  },
}

const defaultValue = {
  messages: [],
  setMessages: () => {},
  chat: {},
  setChat: () => {},
  routes: {
    readMessages: async () => {
      return defaultMessageReturn
    },
    sendMessage: async () => {
      return defaultMessageReturn
    },
    deleteMessage: async () => {
      return defaultMessageReturn
    },
    updateMessage: async () => {
      return defaultMessageReturn
    },
    getChat: async () => {
      return defaultChatReturn
    },
  },
}

const MessageCenterChatManagerContext = createContext<MessageCenterChatManagerContext>(defaultValue)

export default MessageCenterChatManagerContext
